/* MarahKids cart redesign — FBT recommendations + sticky bar sync (draft 156912320664) */
(function () {
  'use strict';

  function money(cents) {
    var v = (cents || 0) / 100;
    var hasFrac = Math.round(v * 100) % 100 !== 0;
    return 'AED ' + v.toLocaleString('en-US', {
      minimumFractionDigits: hasFrac ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  function cartRowIdentity(row) {
    var variantId = row.getAttribute('data-variant-id');
    if (variantId) return 'variant:' + variantId;

    var key = row.getAttribute('data-cart-line-key');
    if (key) return 'key:' + key;

    var link = row.querySelector('.cart-item__name');
    var href = link && link.getAttribute('href');
    if (href) return 'href:' + href.split('?')[0];

    var name = link && link.textContent ? link.textContent.trim().replace(/\s+/g, ' ').toLowerCase() : '';
    return name ? 'name:' + name : '';
  }

  function hasDuplicateCartRows() {
    var seen = {};
    var rows = document.querySelectorAll('.cart-item');
    for (var i = 0; i < rows.length; i++) {
      var id = cartRowIdentity(rows[i]);
      if (!id) continue;
      if (seen[id]) return true;
      seen[id] = true;
    }
    return false;
  }

  function duplicateItemIdentity(item) {
    if (item && item.variant_id) return 'variant:' + item.variant_id;
    if (item && item.key) return 'key:' + item.key;
    if (item && item.product_title) return 'title:' + String(item.product_title).toLowerCase();
    return '';
  }

  function duplicateCartUpdates(cart) {
    var groups = {};
    var updates = {};
    var hasUpdates = false;

    (cart.items || []).forEach(function (item) {
      var id = duplicateItemIdentity(item);
      if (!id) return;
      if (!groups[id]) groups[id] = [];
      groups[id].push(item);
    });

    Object.keys(groups).forEach(function (id) {
      var items = groups[id];
      if (items.length < 2 || !items[0].key) return;

      var total = items.reduce(function (sum, item) {
        return sum + (parseInt(item.quantity, 10) || 0);
      }, 0);

      updates[items[0].key] = total;
      for (var i = 1; i < items.length; i++) {
        if (items[i].key) updates[items[i].key] = 0;
      }
      hasUpdates = true;
    });

    return hasUpdates ? updates : null;
  }

  var duplicateRecoveryInProgress = false;

  function normalizeDuplicateCartRows() {
    if (duplicateRecoveryInProgress) return;
    duplicateRecoveryInProgress = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = duplicateCartUpdates(cart);
        if (!updates) {
          window.location.reload();
          return null;
        }

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          window.location.reload();
        });
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function duplicateRecoveryKey() {
    return window.location.pathname + window.location.search;
  }

  function scheduleDuplicateCartRecovery() {
    if (!hasDuplicateCartRows()) {
      try { sessionStorage.removeItem('mkCartDuplicateRecovery'); } catch (e) {}
      return;
    }

    var key = duplicateRecoveryKey();
    var marker = '';
    try { marker = sessionStorage.getItem('mkCartDuplicateRecovery') || ''; } catch (e) {}
    if (marker === key) return;

    try { sessionStorage.setItem('mkCartDuplicateRecovery', key); } catch (e) {}
    setTimeout(function () {
      normalizeDuplicateCartRows();
    }, 120);
  }

  function watchDuplicateCartRows() {
    var cartItems = document.querySelector('cart-items');
    var timer;

    if (cartItems && window.MutationObserver) {
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(scheduleDuplicateCartRecovery, 120);
      }).observe(cartItems, { childList: true, subtree: true });
    }

    scheduleDuplicateCartRecovery();
    setTimeout(scheduleDuplicateCartRecovery, 700);
    setTimeout(scheduleDuplicateCartRecovery, 1800);
  }

  /* ---------------- sticky bar total/count sync ---------------- */
  function syncSticky() {
    var bar = document.querySelector('[data-mk-sticky]');
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // keep the "Your Cart (N)" title count in sync (it lives outside cart.js's re-render scope)
        var cc = document.querySelector('[data-cart-count]');
        if (cc) cc.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
        if (bar) {
          var countEl = bar.querySelector('[data-mk-sticky-count]');
          var totalEl = bar.querySelector('[data-mk-sticky-total]');
          if (countEl) countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'Item' : 'Items');
          if (totalEl) totalEl.textContent = money(cart.total_price);
          if (cart.item_count === 0) {
            bar.style.display = 'none';
            document.documentElement.classList.remove('cart-has-sticky');
            var ct = document.querySelector('.cart-template'); if (ct) ct.classList.remove('cart-has-sticky');
          }
        }
      })
      .catch(function () {});
  }

  function scheduleSync() {
    // run a few times to reliably catch the updated cart regardless of cart.js timing
    setTimeout(syncSticky, 500);
    setTimeout(syncSticky, 1200);
    setTimeout(syncSticky, 2200);
  }
  function watchCartChanges() {
    // Delegate on document — robust even if the theme/apps re-render or REPLACE the cart markup
    // (a MutationObserver bound to #main-cart-items gets orphaned when that node is replaced).
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('quantity__input')) scheduleSync();
    });
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('cart-remove-button, .quantity__button')) scheduleSync();
    });
    // backup: observe the (stable) <cart-items> custom element subtree
    var ci = document.querySelector('cart-items');
    if (ci) { var tm; new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(syncSticky, 300); }).observe(ci, { childList: true, subtree: true }); }
  }

  /* ---------------- Frequently Bought Together ---------------- */
  function firstAvailableVariant(p) {
    if (!p.variants || !p.variants.length) return null;
    return p.variants.find(function (v) { return v.available; }) || p.variants[0];
  }

  function recUrl(baseId, intent, limit) {
    return '/recommendations/products.json?product_id=' + encodeURIComponent(baseId) +
      '&limit=' + limit + '&intent=' + intent;
  }

  function renderFbt(container, products, limit, inCartIds) {
    var grid = container.querySelector('[data-mk-fbt-grid]');
    var addBtn = container.querySelector('[data-mk-fbt-addall]');
    var addLbl = container.querySelector('[data-mk-fbt-addall-label]');
    if (!grid) return;

    var picked = products
      .filter(function (p) { return p.available && inCartIds.indexOf(String(p.id)) === -1; })
      .filter(function (p) { return firstAvailableVariant(p); })
      .slice(0, limit);

    if (!picked.length) { container.hidden = true; return; }

    grid.innerHTML = '';
    picked.forEach(function (p) {
      var v = firstAvailableVariant(p);
      if (!v) return;
      var img = '';
      if (v && v.featured_image) img = v.featured_image.src || v.featured_image;
      if (!img && p.featured_image) img = p.featured_image.src || p.featured_image;
      if (!img && p.images && p.images[0]) img = p.images[0].src || p.images[0];
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var imgSrc = img ? (img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200') : '';
      var safeTitle = (p.title || 'product').replace(/"/g, '&quot;');
      var card = document.createElement('label');
      card.className = 'mk-fbt__card';
      card.innerHTML =
        '<span class="mk-fbt__check"><svg class="mk-ic" viewBox="0 0 24 24" fill="none"><path d="m5 12.5 4.5 4.5L19 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '<input type="checkbox" value="' + v.id + '" data-price="' + v.price + '" aria-label="Add ' + safeTitle + '">' +
        (imgSrc ? '<img class="mk-fbt__img" src="' + imgSrc + '" alt="" loading="lazy">' : '<span class="mk-fbt__img"></span>') +
        '<span class="mk-fbt__name">' + (p.title || '') + '</span>' +
        '<span class="mk-fbt__price">' + money(v.price) + '</span>';
      grid.appendChild(card);
    });

    container.hidden = false;

    // slider arrows — show only when the track overflows (desktop; mobile uses swipe)
    var nav = container.querySelector('[data-mk-fbt-nav]');
    var prevBtn = container.querySelector('[data-mk-fbt-prev]');
    var nextBtn = container.querySelector('[data-mk-fbt-next]');
    var step = function () { return Math.max(160, Math.round(grid.clientWidth * 0.8)); };
    var updateNav = function () { if (nav) nav.hidden = !(grid.scrollWidth > grid.clientWidth + 4); };
    if (prevBtn) prevBtn.addEventListener('click', function () { grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { grid.scrollBy({ left: step(), behavior: 'smooth' }); });
    updateNav();
    window.addEventListener('resize', updateNav);

    var checks = grid.querySelectorAll('input[type="checkbox"]');
    function refresh() {
      var sel = [], sum = 0;
      checks.forEach(function (c) {
        c.closest('.mk-fbt__card').classList.toggle('is-checked', c.checked);
        if (c.checked) { sel.push(c.value); sum += parseInt(c.getAttribute('data-price'), 10) || 0; }
      });
      addBtn.disabled = sel.length === 0;
      addLbl.textContent = sel.length
        ? 'Add ' + sel.length + ' ' + (sel.length === 1 ? 'item' : 'items') + ' • +' + money(sum)
        : 'Add selected';
      return sel;
    }
    // stop the checkbox 'change' from bubbling to <cart-items> (Dawn's cart.js change
    // listener would otherwise treat it as a line-item quantity update and error out)
    checks.forEach(function (c) { c.addEventListener('change', function (e) { e.stopPropagation(); refresh(); }); });
    refresh();

    addBtn.addEventListener('click', function () {
      var sel = refresh();
      if (!sel.length) return;
      addBtn.disabled = true;
      addLbl.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: sel.map(function (id) { return { id: id, quantity: 1 }; }) })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok || (res.d && res.d.errors)) { addBtn.disabled = false; addLbl.textContent = 'Item unavailable'; return; }
          window.location.reload();
        })
        .catch(function () { addBtn.disabled = false; addLbl.textContent = 'Try again'; });
    });
  }

  function fetchJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function collUrl(handle, limit) {
    return '/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + limit;
  }
  // /recommendations returns prices in CENTS; /collections/*/products.json returns DECIMAL
  // strings — normalise everything to integer cents + a product-level `available` flag.
  function normalize(products) {
    (products || []).forEach(function (p) {
      var vs = p.variants || [];
      vs.forEach(function (v) {
        if (typeof v.price === 'string') {
          v.price = v.price.indexOf('.') > -1 ? Math.round(parseFloat(v.price) * 100) : parseInt(v.price, 10);
        }
      });
      if (typeof p.available === 'undefined') { p.available = vs.some(function (v) { return v.available; }); }
    });
    return products || [];
  }
  function mergeUnique() {
    var seen = {}, out = [];
    for (var i = 0; i < arguments.length; i++) {
      (arguments[i] || []).forEach(function (p) { if (p && !seen[p.id]) { seen[p.id] = 1; out.push(p); } });
    }
    return out;
  }
  function fetchCollections(handles, need) {
    var acc = [];
    function step(i) {
      if (i >= handles.length || acc.length >= need) return Promise.resolve(acc);
      return fetchJson(collUrl(handles[i], 24)).then(function (d) {
        if (d && d.products) acc = mergeUnique(acc, normalize(d.products));
        return step(i + 1);
      });
    }
    return step(0);
  }

  function initFbt() {
    var container = document.querySelector('[data-mk-fbt]');
    if (!container) return;
    var baseId = container.getAttribute('data-base-id');
    var limit = parseInt(container.getAttribute('data-limit'), 10) || 8;
    var inCartIds = (container.getAttribute('data-in-cart') || '').split(',').filter(Boolean);
    var collections = (container.getAttribute('data-collections') || '').split(',').filter(Boolean);
    if (!baseId) return;
    var need = limit + inCartIds.length + 4;
    function usable(list) {
      return (list || []).filter(function (p) {
        return p && inCartIds.indexOf(String(p.id)) === -1 && String(p.id) !== String(baseId);
      }).length;
    }

    // 1) merchant-curated "complementary" — the true frequently-bought-together / accessories
    fetchJson(recUrl(baseId, 'complementary', need)).then(function (d) {
      var prods = normalize((d && d.products) || []);
      // 2) best-sellers from the anchor product's OWN collection(s) (e.g. pool -> "Pools & Accessories")
      if (usable(prods) >= need || !collections.length) return prods;
      return fetchCollections(collections, need).then(function (coll) { return mergeUnique(prods, coll); });
    }).then(function (prods) {
      // 3) algorithmic "related" as a final fallback
      if (usable(prods) >= Math.min(limit, 4)) return prods;
      return fetchJson(recUrl(baseId, 'related', need)).then(function (d) {
        return mergeUnique(prods, normalize((d && d.products) || []));
      });
    }).then(function (prods) {
      renderFbt(container, prods, limit, inCartIds);
    }).catch(function () { container.hidden = true; });
  }

  function init() {
    if (document.querySelector('[data-mk-sticky]')) {
      document.documentElement.classList.add('cart-has-sticky');
      var ct = document.querySelector('.cart-template') || document.body;
      ct.classList.add('cart-has-sticky');
    }
    syncSticky();
    watchCartChanges();
    watchDuplicateCartRows();
    initFbt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
